import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { IMAGE_BASE } from 'src/config-global';

function normalizeHeight(h) {
  if (h == null) return undefined;
  return typeof h === 'number' ? `${h}px` : h;
}

function buildContainerStyle({ style = {}, borderRadius }) {
  const height = normalizeHeight(style.height);
  return {
    display: style.display || 'inline-flex',
    alignItems: style.alignItems || 'center',
    justifyContent: style.justifyContent || 'center',
    borderRadius: borderRadius || style.borderRadius,
    ...style,
    ...(height ? { height } : {})
  };
}

const Image = forwardRef(
  (
    {
      src,
      alt,
      objectFit = 'cover',
      borderRadius = 'inherit',
      disabledEffect = false,
      disabledBase = false,
      effect = 'blur',
      className,
      style = {},
      ...other
    },
    ref
  ) => {
    const imageSrc = disabledBase ? src : IMAGE_BASE + src;

    const containerStyle = buildContainerStyle({ style, borderRadius });

    const imgStyle = {
      display: 'block',
      objectFit,
      ...(style.height ? { height: style.height } : {})
    };

    return (
      <span ref={ref} className={className} style={containerStyle}>
        <LazyLoadImage src={imageSrc} alt={alt} effect={disabledEffect ? undefined : effect} style={imgStyle} {...other} />
      </span>
    );
  }
);

Image.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  objectFit: PropTypes.string,
  borderRadius: PropTypes.string,
  disabledEffect: PropTypes.bool,
  disabledBase: PropTypes.bool,
  effect: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};

export default Image;
